import { Injectable } from '@angular/core';

import { BehaviorSubject, distinctUntilChanged, filter } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MainContentLoaded {
    #loaded$ = new BehaviorSubject(false);
    loaded$ = this.#loaded$.pipe(distinctUntilChanged(), filter(Boolean));

    setLoaded(): void {
        this.#loaded$.next(true);
    }
}
